export default __webpack_public_path__ + "static/media/G0002.c770a120.png";